var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line pifa-item",class:{ active: _vm.active }},[_c('div',{staticClass:"name"},[_vm._v("· "+_vm._s(_vm.data.name))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.data.num))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.data.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }